import HubSaude from "@/pages/hub-saude/index.vue";
import HubSaudeHome from "@/pages/hub-saude/home.vue";
import HubSaudeProgramas from "@/pages/hub-saude/programas.vue";
import HubSaudeProgramaDetalhe from "@/pages/hub-saude/programa-detalhe.vue";
import HubSaudeComoFunciona from "@/pages/hub-saude/como-funciona.vue";
import HubSaudeTeleconsultas from "@/pages/hub-saude/teleconsultas.vue";

const hubMeta = {
  checkPathDisabled: true,
  registerAccess: {
    servico: "Hub de Saúde",
    funcionalidade: "Acesso ao Hub de saúde"
  }
};

const routes: Route[] = [
  {
    path: "/hub-de-saude",
    component: HubSaude,
    children: [
      {
        path: "",
        name: "hub_saude.home",
        component: HubSaudeHome,
        meta: {
          ...hubMeta,
          backTo: "/"
        }
      },
      {
        path: "programas",
        name: "hub_saude.programas",
        component: HubSaudeProgramas,
        meta: {
          ...hubMeta,
          backTo: "/hub-de-saude"
        }
      },
      {
        path: "programas/:slug",
        name: "hub_saude.programa",
        component: HubSaudeProgramaDetalhe,
        meta: {
          ...hubMeta,
          backTo: "/hub-de-saude/programas"
        }
      },
      {
        path: "programas/:slug/como-funciona",
        name: "hub_saude.como_funciona",
        component: HubSaudeComoFunciona,
        meta: {
          ...hubMeta,
          backTo: "/hub-de-saude/programas"
        }
      },
      {
        path: "teleconsultas",
        name: "hub_saude.teleconsultas",
        component: HubSaudeTeleconsultas,
        meta: {
          ...hubMeta,
          backTo: "/hub-de-saude"
        }
      }
    ]
  }
];

export default routes;
